import { Navigate, useLocation } from 'react-router-dom'
import type { BillingTab } from './billingState'

/**
 * Where an old address lands (plan E5): `/billing` with the section as `?tab=`, every other query parameter kept —
 * `umzug=1` from the migration mail, `checkout=…` from the provider's return URL. An old `tab` is overwritten: the
 * old path names the section.
 */
export function billingTargetFor(search: string, tab: BillingTab, hash = ''): string {
  const params = new URLSearchParams(search)
  params.set('tab', tab)
  return `/billing?${params.toString()}${hash}`
}

function LegacyBillingRedirect({ tab }: { tab: BillingTab }) {
  const { search, hash } = useLocation()
  return <Navigate to={billingTargetFor(search, tab, hash)} replace />
}

/** `/subscription` → `/billing?tab=plans` (links in mails, the provider's return URL, bookmarks). */
export function SubscriptionRedirect() {
  return <LegacyBillingRedirect tab="plans" />
}

/** `/usage` → `/billing?tab=usage`. */
export function UsageRedirect() {
  return <LegacyBillingRedirect tab="usage" />
}
